<mat-form-field>
  <mat-icon matPrefix *ngIf="prefixIcon">{{ prefixIcon }}</mat-icon>
  <img
    alt="address icon"
    matPrefix src="{{prefixIconSvg}}" *ngIf="prefixIconSvg"  />
  <input matInput
         placeholder="{{placeholder}}"
         [(ngModel)]="address" #input/>
</mat-form-field>
